// Versión del sistema NEUROMATEMÁTICAS JASQ®.
// Cambiar APP_VERSION en cada release/iteración para que los usuarios
// puedan verificar visualmente que están usando la build actualizada.
//
// Formato: HITO.FASE.ITERACIÓN (YYYY.MM.DD) — etiqueta opcional.

export const APP_VERSION = "5.7.7";
export const APP_RELEASE_TAG = "Estado real del diagnóstico en el perfil, CEP sin promedio, un solo correo de invitación y mi cámara flotante movible en clases";
export const APP_BUILD_DATE = "2026-11-03";

export const APP_VERSION_LABEL = `v${APP_VERSION} · ${APP_RELEASE_TAG}`;
